import { useEffect } from "react";
import { observer } from "mobx-react-lite";
import { useHistory } from "react-router-dom";
import { accountantMeta, adminMeta } from "../routes/metaData";
const DefaultAccountantScreen = observer((props: any) => {
   const history = useHistory()
   useEffect(() => {
      history.push(accountantMeta[0].path);
      // eslint-disable-next-line react-hooks/exhaustive-deps
   }, []);

   return null;
});

export default DefaultAccountantScreen;
